export default __webpack_public_path__ + "static/media/q26.3874e0f7.png";